import { render } from "./ActiveScreen.vue?vue&type=template&id=f1d3ffa6&scoped=true"
import script from "./ActiveScreen.vue?vue&type=script&lang=js"
export * from "./ActiveScreen.vue?vue&type=script&lang=js"

import "./ActiveScreen.vue?vue&type=style&index=0&id=f1d3ffa6&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d3ffa6"]])

export default __exports__